import Model from "./Model";

export default class BookingFormModel extends Model {
    constructor(bookingForm) {

        super(bookingForm.data);

        this.PARTICIPANTS_MAX = bookingForm.PARTICIPANTS_MAX;
        this.travel_date = bookingForm.travel_date;
        this.travel = bookingForm.travel;
        this.participants = bookingForm.participants;
        this.price = bookingForm.price;
        this.steps = bookingForm.steps;
        this.step_current = bookingForm.step_current;
        this.step_next = bookingForm.step_next;
        this.step_back = bookingForm.step_back;

        // console.log(this.get('participants'));
    }

    get firstParticipant() {
        return this.get('participants.0', null);
    }

    booker(data) {
        const propterties = BookingFormModel.bookerProperties();
        let booker = {};
        propterties.forEach((key) => {
            booker[key] = typeof data[key] == 'undefined' ? null : data[key];
        });
        this.data.booker = booker;
        return this;
    }

    addParticipant(participant, price) {
        let push = { index: _.size(this.data.participants), price: price };
        const propterties = BookingFormModel.participantProperties(["index", "price"]);
        propterties.forEach((key) => {
            push[key] = typeof participant[key] == 'undefined' ? null : participant[key];
        });
        this.data.participants.push(push)
        return this;
    }

    editParticipant(index, participant, price) {
        let merge = { price: price };
        const propterties = BookingFormModel.participantProperties(["index", "price"]);
        propterties.forEach((key) => {
            merge[key] = typeof participant[key] == 'undefined' ? null : participant[key];
        });
        this.data.participants[index] = {
            ...this.data.participants[index],
            ...merge
        };
        return this;
    }

    removeParticipant(index) {
        this.data.participants.splice(index, 1);
        return this;
    }

    static participantProperties(remove = []) {
        return [
            "index",
            "gender",
            "birthday",
            "age",
            "firstname",
            "lastname",
            "address_differs",
            "street",
            "street_no",
            "zip",
            "city",
            "mobile",
            "email",
            "room_id",
            "arrival",
            "arrival_bus_relax_id",
            "arrival_train_uex_id",
            "boarding_id",
            "ski_pass_id",
            "key_card_id",
            "selfdrive_discount_id",
            "ski_school_id",
            "ski_rental_id",
            "invoice",
            "note",
            "price",
        ].filter((value) => !_.includes(remove, value));
    }

    static bookerProperties() {
        return BookingFormModel.participantProperties([
            "index",
            "age",
            "address_differs",
            "room_id",
            "arrival",
            "arrival_bus_relax_id",
            "arrival_train_uex_id",
            "boarding_id",
            "ski_pass_id",
            "key_card_id",
            "selfdrive_discount_id",
            "ski_school_id",
            "ski_rental_id",
            "invoice",
            "note",
            "price",
        ]);
    }

    setSession(session) {
        this.session = session;
        return this;
    }

    toStorage() {
        this.session.set("booking_form", this.data);
        return this;
    }

    syncToServer() {
        return this.session.syncToServer();
    }
}
